import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { categories } from "@/mocks/topics";

const stats = [
  { value: "12,600+", label: "累计收录话题" },
  { value: "38", label: "每日更新条数" },
  { value: "6", label: "内容分类" },
];

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/topics?query=${encodeURIComponent(q)}` : "/topics");
  };

  return (
    <section className="relative w-full h-[520px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20editorial%20abstract%20collage%20background%20with%20coral%20red%20amber%20gold%20and%20cream%20paper%20texture%2C%20subtle%20geometric%20shapes%20and%20soft%20grain%2C%20magazine%20cover%20aesthetic%2C%20artistic%20and%20modern&width=1600&height=900&seq=kanliao-hero-01&orientation=landscape"
        alt="5看料网首页背景 - 热点话题与娱乐资讯聚合平台"
        title="5看料网 - 热点话题与娱乐资讯聚合"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/45 to-foreground-950/65"></div>

      <div className="relative z-10 w-full h-full px-4 md:px-8 flex flex-col items-center justify-center text-center">
        <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full border border-background-50/35 bg-background-50/10 text-background-100 text-xs md:text-sm">
          <i className="ri-flashlight-line text-accent-300"></i>
          每日热点 · 话题聚合
        </span>

        <h1 className="mt-6 font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight max-w-4xl">
          热点不漏料，好料随手存
        </h1>

        <p className="mt-5 max-w-2xl text-sm md:text-lg leading-8 text-background-100/90">
          在 5看料网，你可以轻松完成收藏、保存、书签、记录与标记操作，对感兴趣的娱乐动态与网络热议持续关注，
          方便后续随时回看，不错过任何一条重要爆料。
        </p>

        <form
          onSubmit={onSubmit}
          className="mt-8 w-full max-w-xl flex flex-col sm:flex-row gap-3 sm:gap-0 sm:bg-background-50 sm:rounded-full sm:p-1.5"
        >
          <label htmlFor="hero-search" className="sr-only">
            搜索话题
          </label>
          <div className="flex items-center gap-2 flex-1 px-4 py-3 sm:py-2 rounded-md sm:rounded-full bg-background-50 sm:bg-transparent">
            <i className="ri-search-line text-foreground-500"></i>
            <input
              id="hero-search"
              name="keyword"
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索话题、艺人或节目名称"
              className="flex-1 bg-transparent text-sm text-foreground-950 placeholder:text-foreground-500 outline-none"
            />
          </div>
          <button
            type="submit"
            className="px-6 py-3 rounded-md sm:rounded-full bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            搜索话题
          </button>
        </form>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          {categories.slice(1, 6).map((cat) => (
            <Link
              key={cat.key}
              to={`/topics?category=${encodeURIComponent(cat.key)}`}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-background-50/30 text-background-100 text-xs hover:bg-background-50/15 transition-colors cursor-pointer"
            >
              <i className={cat.icon}></i>
              {cat.key}
            </Link>
          ))}
        </div>

        <div className="mt-10 hidden md:flex items-center gap-10">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <div className="font-heading text-2xl font-bold text-accent-300">{s.value}</div>
              <div className="mt-1 text-xs text-background-100/80">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}